export function normalizeIndex(values) {
  return values.reduce((acc, cur) => {
    acc[cur.value] = cur.label;
    return acc;
  }, {});
}
